import { error } from "jquery";
import axiosInstance from "../../../axios/axios";

export function createShowEntry(action = "", horseList = [], showId) {
    const ownerId = localStorage.getItem('currentSubAccountId') ?? '';
    const sendedHorses = horseList.map((horse, index) => ({
        horseId: horse?.id,
        showDayId: !!horse?.showDayId ? horse?.showDayId : null
    }));
    const obj = {
        showId: showId,
        actionName: action,
        showParticipantsHorsesList: sendedHorses,
        ownerId: ownerId
    }


    return new Promise((resolve, reject) => {
        axiosInstance.post('/showentry/createshowentry', { ...obj }).then(response => {
            if (response.status == 200) {
                if (response.data.responseCode == "200") {
                    resolve(true);
                } else {
                    resolve(response.data?.responseText)
                }
            }
            resolve(false);
        }).catch(error => reject(false));
    })
}
export function deleteShowEntry(horseId = "") {

    return new Promise((resolve, reject) => {
        axiosInstance.get(`/showentry/deleteshowentry?ShowHorseId=${horseId}`).then(response => {
            if (response.status == 200) {
                if (response.data.responseCode == "200") {
                    resolve(true);
                }
            }
            resolve(false);
        }).catch(error => reject(false));
    })
}

export function getShowEntryHorses(userId = "", showId = '') {
    return new Promise((resolve, reject) => {
        axiosInstance.get(`/ShowEntry/GetShowRequest?id=${userId}&showId=${showId}`).then(response => {
            if (response.status == 200) {
                if (response.data.responseCode == "200") {
                    resolve(response.data?.result ?? [])
                }
            }
            resolve([]);
        }).catch(error => reject(false))
    })
}
export function getCountries() {
    return new Promise((resolve, reject) => {
        axiosInstance.get(`/lookup/getcountries`).then(response => {
            if (response.status == 200) {
                const res = response.data.map((item) => ({
                    label: item?.text,
                    ...item
                }))
                resolve(res ?? [])
            }
            resolve([]);
        }).catch(error => reject([]))
    })
}
export function getHorseColors() {
    return new Promise((resolve, reject) => {
        axiosInstance.get(`/lookup/gethorsecolors`).then(response => {
            if (response.status == 200) {
                if (response.data.responseCode == "200") {
                    const res = response.data?.result.map((item) => ({
                        label: item?.nameEn,
                        text: item?.nameEn,
                        value: item?.id,
                        ...item
                    }))
                    resolve(res ?? [])
                }
            }
            resolve([]);
        }).catch(error => reject([]))
    })
}
export function searchInternationalHorse(name = "", countryId = "", UelnNo = "") {
    return new Promise((resolve, reject) => {
        axiosInstance.get(`/showentry/searchinternationalhorses?Name=${name}&CountryId=${countryId}&UelnNo=${UelnNo}`).then(response => {
            if (response.status == 200) {
                if (response.data.responseCode == "200") {
                    const res = response.data.result;
                    resolve(res ?? [])
                }
            }
            resolve([]);
        }).catch(error => reject([]))
    })
}

export function getInternationalHorseById(horseId, showId = "") {
    return new Promise((resolve, reject) => {
        axiosInstance.get(`/showentry/getinternationalhorsesbyid?id=${horseId}${!!showId && `&showId=${showId}`}`).then(response => {
            if (response.status == 200) {
                if (response.data.responseCode == "200") {
                    const res = response.data.result;
                    resolve(res ?? [])
                }
            }
            resolve([]);
        }).catch(error => reject([]))
    })
}

export function addEditInternationalHorse(formData) {
    return new Promise((resolve, reject) => {
        axiosInstance.post(`/showentry/addeditinternationalhorse`, formData, {
            headers: {
                'content-type': 'multipart/form-data',
            }
        }).then(response => {
            if (response.status == 200) {
                if (response.data.responseCode == "200") {
                    const res = response.data.result;
                    resolve(res ?? false)
                }
            }
            resolve(false);
        }).catch(error => reject(false))
    })

}
export function addedithorsequalification(obj) {
    return new Promise((resolve, reject) => {
        axiosInstance.post(`/showentry/addedithorsequalification`, obj,).then(response => {
            if (response.status == 200) {
                if (response.data.responseCode == "200") {
                    const res = true;
                    resolve(res ?? false)
                }
            }
            resolve(false);
        }).catch(error => reject(false))
    })
}

export function gethorsequalificationbyhorseid(horseId) {
    return new Promise((resolve, reject) => {
        axiosInstance.get(`/showentry/gethorsequalificationbyhorseid?horseId=${horseId}`,).then(response => {
            if (response.status == 200) {
                if (response.data.responseCode == "200") {
                    const res = response.data.result;
                    resolve(res ?? false)
                }
            }
            resolve(false);
        }).catch(error => reject(false))
    })
}
export function getHorseCertificates(horseId) {
    return new Promise((resolve, reject) => {
        axiosInstance.get(`/showentry/getHorseCertificate?id=${horseId}`,).then(response => {
            if (response.status == 200) {
                if (response.data.responseCode == "200") {
                    const res = response.data.result;
                    resolve(res ?? false)
                }
            }
            resolve(false);
        }).catch(error => reject(false))
    })
}
export function addHorseCertificates(formData) {
    return new Promise((resolve, reject) => {
        axiosInstance.post(`/showentry/addHorseCertificate`, formData, {
            headers: {
                'content-type': 'multipart/form-data',
            }
        }).then(response => {
            if (response.status == 200) {
                if (response.data.responseCode == "200") {
                    const res = true;
                    resolve(res ?? false)
                }
            }
            resolve(false);
        }).catch(error => reject(false))
    })
}

export function getReplacementOwnerHorses(obj) {
    return new Promise((resolve, reject) => {
        axiosInstance.post('/ShowEntry/GetReplacementOwnerHorses', {
            showId: obj?.showId,
            ownerId: obj?.ownerId,
            horseId: obj?.horseId,
            searchValue: obj?.searchValue ?? null,
            skip: obj?.skip ?? 0,
            take: obj?.take ?? 100,
            langauge: obj?.langauge ?? (localStorage.getItem('eahsLang') ?? 'ar'),
        }).then(response => {
            if (response.status == 200) {
                const horses = response.data?.horsesList ?? response.data?.result ?? [];
                resolve({
                    totalCount: response.data?.totalCount ?? horses.length,
                    horsesList: horses
                });
            } else {
                resolve({ totalCount: 0, horsesList: [] });
            }
        }).catch(error => reject(error));
    });
}

export function replaceShowEntryHorse(obj) {
    const formData = new FormData();
    if (obj?.showId) formData.append('ShowId', obj?.showId);
    if (obj?.oldHorseId) formData.append('OldHorseId', obj?.oldHorseId);
    if (obj?.newHorseId) formData.append('NewHorseId', obj?.newHorseId);

    return new Promise((resolve, reject) => {
        axiosInstance.post('/ShowEntry/ReplaceShowEntryHorse', formData, {
            headers: {
                'content-type': 'multipart/form-data',
            }
        }).then(response => {
            if (response.status == 200) {
                if (response.data.responseCode == "200" || response.data.responseCode == 200) {
                    resolve(true);
                } else {
                    resolve(response.data?.responseText || false);
                }
            } else {
                resolve(false);
            }
        }).catch(error => reject(error));
    });
}
